import React from 'react';
import imgImage40 from '../../assets/sections/85451ec1f1491a952558275f342cefa9e211a0a6.png';
import imgENhom81 from '../../assets/sections/0cadf9f002149e3d2a305fa6a0d7ce4d490e101b.png';
import imgTopcvLogoOnDarkBlue1Vectorized from '../../assets/sections/b6d3d607d69c7aab1ca0ef4d3b848ac99917a1ce.svg';
import imgImage39 from '../../assets/sections/a161c0f4ed7e5b49df24bb342843a41a9ae34f55.svg';
import imgEllipse3 from '../../assets/sections/36ccbbcfa17514077ebdccf3d71fd43b2538763a.svg';
import imgEllipse2 from '../../assets/sections/6998d203b7173b478d2a6c94345bedf259bbb642.svg';


export default function PremiumAccount() {
  return (
    <div className="bg-white relative w-[1921px] h-[1080px]" data-node-id="237:630">
      <div className="absolute bg-[#012e2a] h-[1080px] left-[-37px] top-0 w-[1995px]" data-name="image 7" data-node-id="237:631" />
      <div className="absolute inset-[26.11%_73.4%_30.73%_-30.45%]" data-name="TOPCV_LOGO_ON-DARK-BLUE 1 [Vectorized]" data-node-id="237:836">
        <img alt="" className="absolute block max-w-none size-full" src={imgTopcvLogoOnDarkBlue1Vectorized} />
      </div>
      <div className="absolute contents left-[-377px] top-[-1px]" data-node-id="237:780">
        <div
          className="absolute h-[596px] left-[-377px] top-0 w-[1920px]"
          data-name="image 39"
          data-node-id="237:782"
          style={{ maskImage: `url('${imgImage39}')`, WebkitMaskImage: `url('${imgImage39}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '0px -1px', WebkitMaskPosition: '0px -1px', maskSize: '1920px 598px', WebkitMaskSize: '1920px 598px' }}>
          <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage40} />
        </div>
      </div>
      <div className="absolute left-[-169px] size-[1325px] top-[885px]" data-node-id="237:773">
        <img alt="" className="absolute block max-w-none size-full" src={imgEllipse3} />
      </div>
      <div className="absolute h-[863px] left-[-754px] top-[-553px] w-[1170px]" data-node-id="237:768">
        <div className="absolute inset-[-79.26%_-58.46%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>
      <div className="-translate-y-1/2 absolute content-stretch flex flex-col gap-[44px] items-start left-[807px] px-[56px] py-[70px] rounded-[16px] top-1/2" data-node-id="237:676">
        <div aria-hidden="true" className="absolute bg-[rgba(255,255,255,0.1)] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-bold leading-[normal] relative shrink-0 text-[#d4f8eb] text-[46px] text-shadow-[5px_9px_32.7px_rgba(255,255,255,0.25)] uppercase whitespace-nowrap" data-node-id="237:701">
          TÀI KHOẢN TOPCV PREMIUM
        </p>
        <div className="content-stretch flex flex-col font-['Alexandria',sans-serif] font-normal gap-[16px] items-start leading-[33px] relative shrink-0 text-[24px] text-white" data-node-id="237:704">
          <p className="relative shrink-0 w-[829px]" data-node-id="237:680">Thời hạn sử dụng: 12 tháng</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:681">Tạo và quản lý tối đa 12 CV</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:682">Tạo và quản lý tối đa 12 Cover Letter</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:683">Tải CV và Cover Letter trong 3 giây Có biểu tượng xác minh tài khoản</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:684">Sử dụng mẫu CV Cao Cấp</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:685">Sử dụng mẫu Cover Letter Cao Cấp Ẩn biểu tượng @topcv.vn</p>
          <p className="relative shrink-0 w-[829px]" data-node-id="237:686">Nhận gói quà tặng từ đối tác Gitiho (Tài khoản PRO trị giá 299k; Khóa học Tin học VP: Word / Excel / PowerPoint)</p>
        </div>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute h-[719px] left-[-144px] top-[368px] w-[1079px]" data-name="E - Nhóm 8 1" data-node-id="237:771">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgENhom81} />
      </div>
    </div>
  );
}
